import React from "react"
import {FieldManagementFormProps} from "../../render/management-form";

export default function FieldProto_ManagementFormCFV1(props:FieldManagementFormProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.managementFormCFV1</div>
    )

}